<template>
  <div class="row form-haeder q-mb-lg">
    <div
      v-for="(category, index) in props.list"
      :key="index"
      class="col d-flex justify-center"
      :class="[
        props.page >= index && 'font-weight-bold',
        props.page === index && 'checked',
        props.page < index && 'yet',
      ]"
    >
      <div class="text-center">
        <div class="number q-mb-sm flex items-center justify-center">
          <p>{{ index + 1 }}</p>
        </div>
        <p class="category-name">{{ category }}</p>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
interface Props {
  list: Array<string>;
  page: number;
}
const props = defineProps<Props>();
</script>
<style scoped>
.form-haeder {
  width: 80%;
  margin: 0 auto 2%;
}
.form-haeder .col {
  color: var(--q-dark);
  position: relative;
}
.form-haeder .col.checked {
  color: var(--q-primary);
}

.form-haeder .col .number {
  width: 1.8rem;
  height: 1.8rem;
  margin: 0 auto;
  border-radius: 50%;
  border: 1px solid;
}
.form-haeder .col.font-weight-bold .number {
  border: 2px solid;
}

.form-haeder .col .number p {
  font-size: 1.1rem;
  line-height: 1.1rem;
  margin: 0;
}
.form-haeder .col:not(:last-child)::after {
  content: '';
  width: 42%;
  height: 2px;
  background: var(--q-dark);
  position: absolute;
  top: 30%;
  right: 0;
  opacity: 0.6;
}
.form-haeder .col:not(:first-child)::before {
  content: '';
  width: 42%;
  height: 2px;
  background: var(--q-dark);
  position: absolute;
  top: 30%;
  left: 0;
  opacity: 0.6;
}
.category-name {
  margin: 5px 0 0;
}

.yet .number {
  opacity: 0.6;
}
</style>
